module.exports = __webpack_public_path__ + "static/img/bg@2x_app.5cf5b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/JuneRecharge/bg@2x_app.png
// module id = Wqn7
// module chunks = 69